export const projectsData = [
  {
    id: 1,
    image: "/assets/financial-projection.png",
    title: "Financial projection application",
    description:
      "This is a financial projection application that help people to know their financial situation from the present day to their retirement plan. It gives an idea if the vehicule they choose will help them to achieve the quality of life they want. I have used NextJS, TypeScript, and Tailwind CSS with other libraries.",
    github: "https://github.com/Ekamba?tab=repositories",
    liveDemo: "https://financial-projection.vercel.app/",
  },
  {
    id: 2,
    image: "/assets/protein-calculator.png",
    title: "Protein calculator Application",
    description:
      "This a protein calculator that help people to know how much protein they get daily according to the meal they having.",
    github: "https://github.com/Ekamba?tab=repositories",
    liveDemo: "https://protein-calculator-lyart.vercel.app/",
  },
  {
    id: 3,
    image: "/assets/business.png",
    title: "Business Application",
    description:
      "This is a business application to help people in different ways. Their career professional, their preventive health, and their personal development. I have used NextJS, TypeScript, and Tailwind CSS with to build the application.",
    github: "https://github.com/Ekamba?tab=repositories",
    liveDemo: "https://business-app-steel.vercel.app/",
  },
];

export const experiencesData = [
  {
    avatar: "/assets/cmr.png",
    name: "Coalescent Mobile Robotics",
    review:
      "The company is specialize for retailing robots to hypermarket. I was developing and maintain the application of the company in team of five software engineers using ReactJS, NodeJS, TypeScript, Style-component...",
  },
  {
    avatar: "/assets/key_icon.png",
    name: "Roomkast Aps",
    review:
      "Using ReactJS, JavaScript and CSS to bring concepts to life. Optimizing the user experience. Developing and maintaining the user interface. Implementing design on mobile websites. Creating tools that improve site interaction regardless of the browser. Managing software workflow. Following SEO best practices. Fixing bugs and testing for usability.",
  },
  {
    avatar: "/assets/bluebenu.png",
    name: "Bluebenu",
    review:
      "Develop and design the software of the company using ReactJS, NodeJS, Express, MongoDB, and Material UI. Maintain and update the software to the latest technology. Identify problems uncovered by customer feedback and testing, and correcting or referring problems to appropriate personnel for correction.",
  },
  {
    avatar: "/assets/ating.jpg",
    name: "Ating Aps",
    review:
      "Build the software using ReactJS and React Native. Determining user needs by analyzing technical requirements. Directing and performing Website update.",
  },
];
